import React, { useState } from 'react';
import { BookMarked, Search } from 'lucide-react';
import { Input } from '../components/ui/input';
import BookCard from '../components/BookCard';
import { BOOKS, SITE } from '../mock/mock';

const PageHero = ({ title, subtitle }) => (
  <section className="hero-gradient">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 text-center">
      <h1 className="font-serif text-4xl md:text-6xl font-bold text-brand-ink fade-up">{title}</h1>
      {subtitle && <p className="mt-4 max-w-2xl mx-auto text-brand-brass font-body text-lg fade-up">{subtitle}</p>}
    </div>
  </section>
);

const BuyABook = () => {
  const [query, setQuery] = useState('');
  const q = query.trim().toLowerCase();
  const filtered = q
    ? BOOKS.filter((b) =>
        [b.title, b.subtitle, b.tag, b.blurb].filter(Boolean).some((f) => f.toLowerCase().includes(q))
      )
    : BOOKS;

  return (
    <div className="fade-in">
      <PageHero
        title="Get Yourself A Copy"
        subtitle="Our non-fiction centers on identity, truth, culture, power, and the human condition—blending personal reflection with philosophy, history, and science."
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-10">
          <div className="flex items-center gap-3">
            <BookMarked className="h-6 w-6 text-brand-gold" />
            <h2 className="font-serif text-2xl font-bold text-brand-ink">The Collection</h2>
          </div>
          <div className="relative w-full sm:w-80">
            <Search className="h-4 w-4 text-brand-brass absolute left-4 top-1/2 -translate-y-1/2" />
            <Input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search books by title or theme..."
              className="bg-white border-brand-goldlight pl-11 h-11 rounded-full"
            />
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-16 text-brand-brown/70">
            <Search className="h-12 w-12 text-brand-goldlight mx-auto mb-4" />
            <p className="font-serif text-xl text-brand-ink">No books match “{query}”</p>
            <p className="mt-1 text-sm">Try a different title or theme.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {filtered.map((b) => (
              <BookCard key={b.id} book={b} />
            ))}
          </div>
        )}
      </section>

      <section className="bg-sand/50">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-14 text-center">
          <h3 className="font-serif text-2xl font-bold text-brand-ink">Follow the Author</h3>
          <p className="text-brand-brown/80 mt-3">
            Faisal K. Sentongo shares thoughts, launches, and behind-the-pages moments.
          </p>
          <a
            href={SITE.authorLinktree}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-6 bg-brand-ink hover:bg-brand-brown text-cream rounded-full px-8 py-3 font-sans transition-colors"
          >
            Visit the Author's Links
          </a>
        </div>
      </section>
    </div>
  );
};

export default BuyABook;
export { PageHero };
